import classNames from "classnames";
import { useState } from "react";
import { useParams } from "react-router";
import { BounceLoader } from "react-spinners";
import { Constants } from "../../../../../common/constants";
import { DashboardUtils } from "../../dashboard_utils";
import { trpc } from "../../utils/trpc";
import { useGuildMemberCache } from "./hooks/use_guild_member_cache";
import { PageButtons } from "./listings_form/page_buttons";
import MemberDisplayNameWithTooltip from "./member_display_name/member_display_name_with_tooltip";
import { WithTooltip } from "./tooltips/with_tooltip";

export function PollResultsVoterList(props: {
	option_index?: number;
	voteBoxCreator: (
		vote_indices: number[],
		include_title?: boolean
	) => JSX.Element;
}) {
	let { server_id, message_id } = useParams<{
		server_id: string;
		message_id: string;
	}>();

	const [page, setPage] = useState(0);

	const members_cache = useGuildMemberCache();

	const voters_query = trpc.poll.voters.useQuery(
		{
			guild_id: server_id,
			message_id,
			option_index: props.option_index,
			page,
		},
		{
			keepPreviousData: true,
			onSuccess: (data) =>
				members_cache.addMembers(
					server_id,
					data.items.map((val) => val)
				),
		}
	);

	if (voters_query.isLoading) {
		return <>{DashboardUtils.RenderLoadingThrobber(undefined, 3)}</>;
	}

	const voters = voters_query.data.items;

	return (
		<div className="flex flex-col gap-4">
			<div
				className={classNames("flex flex-col", {
					"input-disabled": voters_query.isPreviousData,
				})}
			>
				{voters.length === 0 && (
					<div className="bg-base-light py-2 px-4">None</div>
				)}
				{voters.map((val, index) => (
					<div
						key={val.id}
						className={classNames("flex w-full py-2 px-4", {
							"bg-base-primary": index % 2 !== 0,
							"bg-base-light": index % 2 === 0,
						})}
					>
						<WithTooltip
							// trigger_props={{
							// 	className: "w-full",
							// }}
							style="Info"
							tooltip={
								<div className="flex flex-col gap-2">
									<MemberDisplayNameWithTooltip
										user_id={val.id}
										include_avatar
									/>
									<div className="ml-2 flex flex-col">
										{props.voteBoxCreator(val.votes, true)}
									</div>
								</div>
							}
						>
							<div className="flex min-w-full flex-grow cursor-pointer gap-2">
								<MemberDisplayNameWithTooltip
									user_id={val.id}
									include_avatar
									tooltip_type="None"
								/>
								<div className="ml-auto flex">
									{props.voteBoxCreator(val.votes)}
								</div>
							</div>
						</WithTooltip>
					</div>
				))}
			</div>
			<div className="ml-auto">
				<PageButtons
					page={page}
					total_items={voters_query.data.total_item_count}
					setPage={setPage}
					is_loading={voters_query.isPreviousData}
					items_per_page={Constants.POLL_VOTERS_PAGINATION_LIMIT}
				/>
			</div>
		</div>
	);
}
